<template>
  <div class="list-page">
    <div class="layout__content__header d-flex flex-column list-page__header layout__content__header--white">
      <div v-if="projectStore.selectedProject" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
        <h1 class="mb-1 mb-sm-4">
          {{ $t("TRANSFORMATION_FUNCTIONS_LIST_HEADER") }}
        </h1>
        <div
          v-if="projectStore.selectedProject.projectId && projectStore.selectedProject.projectId !== 'undefined'"
          class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between"
        />
        <button class="btn btn-primary d-flex align-items-center justify-content-center" @click="handleCreate">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-nova.svg" />
          </div>
          {{ $t("NEW_TRANSFORMATION_FUNCTION") }}
        </button>
      </div>
    </div>
    <div class="layout__content__content pt-4 pt-md-5">
      <TableV2
        :columns="columns"
        table-id="TF"
        item-id="transformationId"
        :items="itemsForTable"
        :items-total-count="itemsForTable.length"
        kebab
      >
        <template #kebab-actions="{ item }">
          <div class="dropdown-actions__item d-flex align-items-center" @click="handleShowDetail(item)">
            <div class="atom-icon">
              <img src="@/assets/icons/actions/icon_preview_border.svg" />
            </div>
            {{ $t("SHOW_DETAIL") }}
          </div>
          <div class="dropdown-actions__item d-flex align-items-center" @click="handleEdit(item)">
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
            </div>
            {{ $t("EDIT") }}
          </div>
          <div class="dropdown-actions__item d-flex align-items-center" @click="handleDelete(item)">
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
            {{ $t("DELETE_TF") }}
          </div>
        </template>
      </TableV2>
    </div>
    <TransformationFunctionFormModal
      :transformation-function="selectedItem"
      :is-opened="isFormModalOpened"
      :read-only="isFormModalReadOnly"
      @change="getList"
      @close="isFormModalOpened = false"
    />
    <DeleteModal
      :centered="true"
      :items="selectedItem"
      :opened="isDeleteOpened"
      :text="deleteText"
      @close="isDeleteOpened = false"
      @yes="handleDeleteConfirmed"
    />
    <ErrorModal :opened="isErrorOpened" :centered="true" :errors="errors" @close="isErrorOpened = false" />
  </div>
</template>
<script>
import TableV2 from "@/components/custom-table/TableV2.vue"
import { mapMutations } from "vuex"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"
import TransformationFunctionFormModal from "@/components/transformation-functions/TransformationFunctiomFormModal.vue"
import DeleteModal from "@/components/confirmations/delete.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    TableV2,
    ErrorModal,
    DeleteModal,
    TransformationFunctionFormModal
  },
  setup() {
    const projectStore = useProjectStore()
    const tfStore = useTransformationFunctionsStore()

    return { projectStore, tfStore }
  },
  data() {
    return {
      columns: [
        { name: "label", sortable: true, title: "LABEL", minWidth: "220px" },
        { name: "description", sortable: true, title: "DESCRIPTION", minWidth: "400px" },
        { name: "typeDisplay", sortable: true, title: "TF_TYPE", minWidth: "220px" },
        { name: "subType", sortable: true, title: "SUB_TYPE", minWidth: "180px" },
        { name: "publicDisplay", sortable: true, title: "IS_TRANSFORMATION_PUBLIC", minWidth: "160px" },
        { name: "definitionDisplay", sortable: true, title: "DEFINITION", minWidth: "420px" }
      ],
      isFormModalOpened: false,
      selectedItem: {},
      isFormModalReadOnly: true,
      isDeleteOpened: false,
      isErrorOpened: false,
      errors: []
    }
  },
  computed: {
    transformationFunctionList() {
      return this.tfStore.list
    },
    filter() {
      return this.tfStore.filter
    },
    itemsForTable() {
      return this.transformationFunctionList.map((item) => {
        return {
          ...item,
          typeDisplay: this.$t(`${item.type}_TRANSFORMATION`),
          definitionDisplay: `${item.definition.slice(0, 50)}...`,
          publicDisplay: item.public ? this.$t("YES") : this.$t("NO")
        }
      })
    },
    deleteText() {
      return this.selectedItem.label ?? ""
    }
  },
  watch: {
    "projectStore.selectedProject": {
      handler() {
        this.getList()
      },
      immediate: true
    },
    filter: {
      handler() {
        this.getList()
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setNotification: "modals/setGlobalNotification",
      setWaitingLoader: "modals/setWaitingLoader"
    }),
    getList() {
      return this.tfStore.getList()
    },
    deleteTransformationFunction(id) {
      return this.tfStore.deleteTransformation(id)
    },
    updateFilterField(field, value) {
      this.tfStore.updateFilterField(field, value)
    },
    handleShowDetail(item) {
      this.selectedItem = { ...item }
      this.isFormModalReadOnly = true
      this.isFormModalOpened = true
    },
    handleEdit(item) {
      this.selectedItem = { ...item }
      this.isFormModalReadOnly = false
      this.isFormModalOpened = true
    },
    handleCreate() {
      this.selectedItem = {
        label: "",
        description: "",
        type: "",
        subType: "",
        definition: "",
        definitionType: "",
        projectId: this.projectStore.selectedProject.projectId
      }
      this.isFormModalReadOnly = false
      this.isFormModalOpened = true
    },
    handleDelete(item) {
      this.selectedItem = item
      this.isDeleteOpened = true
    },
    async handleDeleteConfirmed() {
      this.setWaitingLoader(this.$t("DELETING"))
      try {
        await this.deleteTransformationFunction(this.selectedItem.transformationId)
        const notification = [
          {
            text: "TRANSFORMATION_FUNCTION_DELETED",
            error: false,
            params: {
              transformationLabel: this.selectedItem.label
            }
          }
        ]
        this.setNotification(notification)
        this.getList()
      } catch (e) {
        this.errors = e.data.errors
        this.isErrorOpened = true
      }
      this.setWaitingLoader("")
      this.isDeleteOpened = false
    }
  }
}
</script>
